import { render, staticRenderFns } from "./AllowancesPlanDetailsFloatBtns.vue?vue&type=template&id=8dd28b5e&"
import script from "./AllowancesPlanDetailsFloatBtns.vue?vue&type=script&lang=js&"
export * from "./AllowancesPlanDetailsFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports